// @flow
import React from "react";
import styled from "styled-components";
import { getImage } from "@nested/utils";
import { media, SmartLink } from "@nested/ui";

const Wrapper = styled.div`
  float: left;
  padding-top: 19px;
  ${media.tablet`
    padding-top: 37px;
  `};
`;

const Logo = () => (
  <Wrapper>
    <SmartLink>
      <img src={getImage("nestedLogo.svg")} alt="" width="100" />
    </SmartLink>
  </Wrapper>
);

export default Logo;
